export interface Rankable {
	label: string
	keywords?: string[]
	description?: string
}

function isSubsequence(query: string, text: string): boolean {
	let i = 0
	for (const char of text) {
		if (char === query[i]) i++
		if (i === query.length) return true
	}
	return i === query.length
}

export function scoreCommand(query: string, item: Rankable): number {
	const q = query.trim().toLowerCase()
	if (!q) return 1

	const label = item.label.toLowerCase()
	if (label === q) return 100
	if (label.startsWith(q)) return 80
	const wordIndex = label.indexOf(` ${q}`)
	if (wordIndex >= 0 || label.includes(`› ${q}`)) return 70
	if (label.includes(q)) return 60

	for (const keyword of item.keywords ?? []) {
		const k = keyword.toLowerCase()
		if (k === q) return 55
		if (k.startsWith(q) || k.includes(q)) return 45
	}

	if (q.length >= 3 && isSubsequence(q, label)) return 20
	if (item.description?.toLowerCase().includes(q)) return 10
	return 0
}

export function rankCommands<T extends Rankable>(query: string, items: T[]): T[] {
	if (!query.trim()) return items
	return items
		.map((item, index) => ({ item, index, score: scoreCommand(query, item) }))
		.filter((entry) => entry.score > 0)
		.sort((a, b) => b.score - a.score || a.index - b.index)
		.map((entry) => entry.item)
}
